// ===============================
// Dawn 15.x — cart-drawer.js (stable fixed version)
// ===============================

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    // Fermer avec Échap
    this.addEventListener('keyup', (evt) => {
      if (evt.code === 'Escape') this.close();
    });

    // Overlay cliquable
    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.addEventListener('click', this.close.bind(this));

    // Accessibilité icône panier
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');

    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });

    cartLink.addEventListener('keydown', (event) => {
      if ((event.code || '').toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  // --- Ouvrir le tiroir ---
  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    // Assure qu’on a un état cohérent
    this.setAttribute('open', '');
    this.classList.add('active', 'animate');

    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.removeEventListener('click', this.close.bind(this));
    if (overlay) overlay.addEventListener('click', this.close.bind(this));

    // Focus et accessibilité
    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement =
          this.querySelector('.drawer__close') ||
          this.querySelector('.drawer__inner');
        if (containerToTrapFocusOn && focusElement) {
          trapFocus(containerToTrapFocusOn, focusElement);
        }
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  // --- Fermer le tiroir ---
  close() {
    this.classList.remove('active', 'animate');
    this.removeAttribute('open');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  // --- Rendu du contenu du panier ---
  renderContents(parsedState) {
    const inner = this.querySelector('.drawer__inner');
    if (inner && inner.classList.contains('is-empty')) {
      inner.classList.remove('is-empty');
    }

    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      if (!sectionElement) return;

      const sectionHtml =
        (parsedState.sections && parsedState.sections[section.id]) || '';
      const next = this.getSectionInnerHTML(sectionHtml, section.selector);
      if (next) sectionElement.innerHTML = next;
    });

    // Réattacher overlay et ouvrir tiroir
    setTimeout(() => {
      const overlay = this.querySelector('#CartDrawer-Overlay');
      if (overlay) overlay.addEventListener('click', this.close.bind(this));
      this.open();
    }, 0);
  }

  // --- Utilitaire : extraire le HTML propre d’une section ---
  getSectionInnerHTML(html, selector = '.shopify-section') {
    try {
      const doc = new DOMParser().parseFromString(html || '', 'text/html');
      const el = doc.querySelector(selector || '.shopify-section');
      return el ? el.innerHTML : '';
    } catch (e) {
      console.warn('[CartDrawer] getSectionInnerHTML failed for', selector, e);
      return '';
    }
  }

  getSectionsToRender() {
    return [
      { id: 'cart-drawer', selector: '#CartDrawer' },
      { id: 'cart-icon-bubble' },
    ];
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

// ===============================
// CartDrawerItems : mise à jour dynamique des items
// ===============================

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      { id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
